<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.02,10.22C13.02,10.22,12.12,11.12,12.12,11.12C12.12,11.12,12.11,11.11,12.11,11.11C11.57,11.66,10.83,12,10,12C8.34,12,7,10.66,7,9C7,8.23,7.3,7.53,7.78,7C7.78,7,4,7,4,7C3.56,7,3.19,7.29,3.06,7.69C3.06,7.69,3.06,7.69,3.06,7.69C3.06,7.69,1.06,13.69,1.06,13.69C1.06,13.69,1.06,13.69,1.06,13.69C1.02,13.78,1,13.89,1,14C1,14.55,1.45,15,2,15C2,15,13,15,13,15C13.44,15,13.81,14.71,13.94,14.31C13.94,14.31,13.94,14.31,13.94,14.31C13.94,14.31,15.05,10.99,15.05,10.99C15.04,10.99,15.02,11,15,11C14.23,11,13.55,10.7,13.02,10.22C13.02,10.22,13.02,10.22,13.02,10.22ZM2.06,6.69C2.2,6.29,2.56,6,3,6C3,6,8.76,6,8.76,6C8.76,6,8.77,5.99,8.77,5.99C8.3,5.46,8,4.77,8,4C8,4,6.41,4,6.41,4C6.41,4,4.71,2.29,4.71,2.29C4.53,2.11,4.28,2,4,2C4,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3,0,12.84,0,12.84C0,12.84,2.05,6.69,2.05,6.69C2.05,6.69,2.06,6.69,2.06,6.69C2.06,6.69,2.06,6.69,2.06,6.69ZM15,3C15,3,11,3,11,3C10.45,3,10,3.45,10,4C10,4.55,10.45,5,11,5C11,5,12.59,5,12.59,5C12.59,5,9.29,8.29,9.29,8.29C9.11,8.469999999999999,9,8.719999999999999,9,9C9,9.55,9.45,10,10,10C10.28,10,10.53,9.89,10.71,9.71C10.71,9.71,14,6.41,14,6.41C14,6.41,14,8,14,8C14,8.55,14.45,9,15,9C15.55,9,16,8.55,16,8C16,8,16,4,16,4C16,3.45,15.55,3,15,3C15,3,15,3,15,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'FolderSharedOpen',
} as DefineComponent
</script>
